import React, { type JSX } from 'react';
import { SnapshotCard } from './SnapshotCard.js';
import { useTranslation } from 'react-i18next';
import { Alert } from 'react-bootstrap';
import { Masonry, ResponsiveMasonry, SHXCol } from '@soulhx/ui-common';
import { fetchPrayerPage, PRAYER_PAGE_SIZE, useAsyncLiveQuery, useUserSetting } from '@soulhx/client-store';
import { BSWindowSize } from '../../hooks/WindowSize.js';
import { ShxHelpText } from '../common/ShxHelpText.js';

interface IPrayerSnapshot {
  addErrorMessage: (message: string | JSX.Element) => void;
}
export const PrayerSnapshot = ({ addErrorMessage }: IPrayerSnapshot) => {
  const { t } = useTranslation(['pray']);
  const { settingValue: sortOrder } = useUserSetting<string>('prayerSort');

  // live: completing an item here (or anywhere) drops it right away. One
  // extra row tells us whether to link to the full prayer page.
  const { data: page } = useAsyncLiveQuery(
    () => fetchPrayerPage(undefined, { sortOrder, showCompleted: false, limit: PRAYER_PAGE_SIZE + 1 }),
    [sortOrder],
    []
  );
  const prayers = page.slice(0, PRAYER_PAGE_SIZE);
  const hasMoreItems = page.length > PRAYER_PAGE_SIZE;

  return (
    <SHXCol grow={2} minWidth="800px">
      <ShxHelpText pageName="home" textName="prayerSnapshot" className="mb-1" />

      <h5 className="text-center">{t('pray:snapshotTitle')}</h5>

      <ResponsiveMasonry
        columnsCountBreakPoints={{
          [BSWindowSize.XS]: 1,
          [BSWindowSize.SM]: 2,
          [BSWindowSize.MD]: 3,
          [BSWindowSize.LG]: 4,
          [BSWindowSize.XL]: 5,
        }}
      >
        <Masonry>
          {prayers.map((item) => (
            <SnapshotCard key={item.id} id={item.id} addErrorMessage={addErrorMessage} />
          ))}
          {hasMoreItems && (
            <Alert variant="light">
              <Alert.Link href="/pray">{t('pray:seeAllItems')}</Alert.Link>
            </Alert>
          )}
          {prayers.length < 1 && <Alert variant="light">{t('pray:noItems')}</Alert>}
        </Masonry>
      </ResponsiveMasonry>
    </SHXCol>
  );
};
